/**
 * Funciones de validación y sanitización de entrada
 * Para prevenir errores de validación y mejorar la seguridad
 */

/**
 * Valida que un email tenga formato válido
 * @param email - Email a validar
 * @returns true si el email es válido, false en caso contrario
 */
export function validateEmail(email: string): boolean {
  if (!email || typeof email !== 'string') return false
  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return re.test(email.trim())
}

/**
 * Valida que un número de teléfono tenga formato válido
 * Acepta números de 10 a 15 dígitos (permite prefijos internacionales)
 * @param phone - Número de teléfono a validar
 * @returns true si el número es válido, false en caso contrario
 */
export function validatePhoneNumber(phone: string): boolean {
  if (!phone || typeof phone !== 'string') return false
  const cleaned = phone.replace(/\D/g, '') // Remover caracteres no numéricos
  return cleaned.length >= 10 && cleaned.length <= 15
}

/**
 * Sanitiza una cadena de texto removiendo caracteres potencialmente peligrosos
 * @param input - Texto a sanitizar
 * @returns Texto sanitizado
 */
export function sanitizeInput(input: string): string {
  if (!input || typeof input !== 'string') return ''
  return input
    .trim()
    .replace(/[<>]/g, '') // Remover caracteres HTML peligrosos
}

/**
 * Enmascara un token mostrando solo los primeros y últimos caracteres
 * Útil para mostrar tokens en listas sin exponerlos completamente
 * @param token - Token a enmascarar
 * @param visibleChars - Número de caracteres visibles al inicio y final (por defecto 4)
 * @returns Token enmascarado (ej: "abcd****wxyz")
 */
export function maskToken(token: string, visibleChars: number = 4): string {
  if (!token || typeof token !== 'string') return '****'
  if (token.length < visibleChars * 2) {
    // Si el token es muy corto, mostrar solo asteriscos
    return '****'
  }
  const first = token.slice(0, visibleChars)
  const last = token.slice(-visibleChars)
  return `${first}${'*'.repeat(Math.max(4, token.length - visibleChars * 2))}${last}`
}

